module.exports = __webpack_public_path__ + "static/img/anli2.d0ad20d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/anli2.jpg
// module id = GbyH
// module chunks = 1